<cm-add-item-dialog title="New HDRI" [confirmDisabled]="!$isFormValid()" [isLoading]="$isLoading()" (confirm)="onConfirm()">
    <div cm-dialog-content class="cm-add-hdri-form">
        <cm-organization-select [usedInAddEntityContext]="true" [updateOrganization]="updateOrganization" [showLabel]="false"> </cm-organization-select>

        <cm-input-container>
            <ng-container cm-inline-label>Name:</ng-container>
            <ng-container cm-input>
                <cm-string-input [value]="$data().name ?? ''" (valueChange)="$data.set({...$data(), name: $event})"></cm-string-input>
            </ng-container>
        </cm-input-container>
    </div>
</cm-add-item-dialog>
